import { fetchUtils } from 'react-admin'
import axios from 'axios'
import { stringify } from 'query-string'
import { getJWT } from '../helper/localStore/getJWT'
import { objectToQueryString } from 'src/helper/objectToQueryString'
const httpClient = fetchUtils.fetchJson

export default {
  getList: async (resource, params) => {
    const { perPage } = params.pagination
    const { field, order } = params.sort

    const { last_id, ...restFilters } = params.filter || {} // Separar last_id del resto de filtros
    let query = {
      limit: JSON.stringify(perPage),
    }

    const { client_hash } = JSON.parse(localStorage.getItem('user'))

    query['order_by'] = `${field}`

    query['order_type'] = `${order}`

    if (resource === 'operation') {
      resource = 'operations/list'
    }

    if (last_id) {
      query['last_id'] = last_id // Añadir el last_id solo una vez en query
    }

    const addFilters = (filter) => {
      if (filter && Object.keys(filter).length > 0) {
        return '&' + objectToQueryString(filter)
      }
      return ''
    }

    const url = `${process.env.REACT_APP_URL_BUCKET}/${resource}/?${stringify(query)}${addFilters(
      restFilters
    )}`
    try {
      const response = await axios.get(url, {
        headers: {
          'authentication-token': getJWT(),
          'hash-client': client_hash,
        },
      })

      const addId = (data) => {
        return (
          data?.items?.map((row) => {
            return {
              ...row,
              id: row.external_id, // data?.external_id para el getOne
              last_id: data?.last_id, // data?.external_id para el paginator
            }
          }) || []
        )
      }
      return {
        data: addId(response.data),
        total: 999999,
        last_id: response.data.last_id,
      }
    } catch (error) {
      console.log('error', error)

      localStorage.removeItem(`RaStore.${resource}.listParams`)
      throw new Error('url not found')
    }
  },
  getOne: (resource, params) => {
    const { client_hash } = JSON.parse(localStorage.getItem('user'))
    return httpClient(
      `${process.env.REACT_APP_URL_BUCKET}/${resource === 'operation' ? 'operations' : resource}/${params.id}`,
      {
        headers: new Headers({
          'authentication-token': getJWT(),
          'hash-client': client_hash,
        }),
      }
    ).then(({ json }) => ({
      data: {
        ...json,
        id: json?.external_id,
      },
    }))
  },

  update: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_PAYMENT}/${resource}/${params.id}`, {
      method: 'PUT',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),

  create: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_PAYMENT}/${resource}/`, {
      method: 'POST',
      body: JSON.stringify(params.data),
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({
      data: { ...params.data, id: json.id },
    })),

  getMany: (resource, params) => {
    return httpClient(
      `${process.env.REACT_APP_URL_RESERVATION}/${resource}/?operator=or&id=${Object.values(
        params.ids
      ).toString()}`,
      {
        headers: new Headers({ 'authentication-token': getJWT() }),
      }
    ).then(({ json }) => {
      return { data: json }
    })
  },

  delete: (resource, params) =>
    httpClient(`${process.env.REACT_APP_URL_PAYMENT}/${resource}/${params.id}`, {
      method: 'DELETE',
      headers: new Headers({ 'authentication-token': getJWT() }),
    }).then(({ json }) => ({ data: json })),
}
